import usePromptFunctionsTabs from '../../../Hooks/usePromptFunctionsTabs';
import ToggleSwitch from '../../Utility/ToggleSwitch';
import { PromptFunctionsTabName } from '../../../Types/Enums';
import PromptFunctionsTab from './components/PromptFunctionsTab';
import McpTab from './components/McpTab';
import AdminContainer from '../../Utility/AdminContainer';
import AdminBox from '../../Utility/AdminBox';
import { RootState, useAppSelector } from '../../../store';
import OpenApiConfigList from './components/OpenApiTab/OpenApiConfigList';

function PromptFunctions() {
    const settings = useAppSelector((state: RootState) => state.settings);
    const { userSettings, i18n, currentTab, setCurrentTab } = usePromptFunctionsTabs();

    return userSettings.isSuperAdmin || settings.demo ? (
        <div className={`admin-container flex relative flex-col`}>
            <AdminContainer>
                <div className="mb-5 w-full">
                    <ToggleSwitch
                        options={[
                            {
                                label: i18n.translate({ id: 'promptFunctions', sourceName: 'PromptFunctions' }),
                                function: () => setCurrentTab(PromptFunctionsTabName.promptFunctions),
                                active: currentTab === PromptFunctionsTabName.promptFunctions,
                            },
                            {
                                label: i18n.translate({ id: 'openApi', sourceName: 'PromptFunctions' }),
                                function: () => setCurrentTab(PromptFunctionsTabName.openApi),
                                active: currentTab === PromptFunctionsTabName.openApi,
                            },
                            {
                                label: 'MCP',
                                function: () => setCurrentTab(PromptFunctionsTabName.mcp),
                                active: currentTab === PromptFunctionsTabName.mcp,
                            },
                        ]}
                    />
                </div>
                <AdminBox classString="px-4">
                    {currentTab === PromptFunctionsTabName.promptFunctions && <PromptFunctionsTab />}
                    {currentTab === PromptFunctionsTabName.openApi && <OpenApiConfigList />}
                    {currentTab === PromptFunctionsTabName.mcp && <McpTab />}
                </AdminBox>
            </AdminContainer>
        </div>
    ) : (
        <></>
    );
}

export default PromptFunctions;
